interface PageBreakMarkerProps {
  /** The `<fp-page-break>` source node id this marker selects. */
  nodeId: string;
}

/**
 * Editor-only "Page break" affordance for the page an `<fp-page-break>` starts,
 * drawn in the page's top margin as chrome rather than content so it costs the
 * document no height and the editor paginates exactly like the preview.
 * @param nodeId - The page break's source node id, making the marker selectable
 */
export function PageBreakMarker({ nodeId }: PageBreakMarkerProps) {
  return (
    <div
      data-fp-node={nodeId}
      className="flex w-full cursor-pointer items-center gap-2 text-[10px] font-semibold uppercase tracking-wider text-gray-400 before:h-px before:flex-1 before:bg-gray-300 after:h-px after:flex-1 after:bg-gray-300"
    >
      Page break
    </div>
  );
}
